
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './program-link.css'

const ProgramLink = ({ className, programLink, children }) => (
    <div className={classNames(className)}>
        <a
            className={classNames(styles.programLink)}
            href={programLink}
            target="_blank"
        >
            {children}
        </a>
    </div>
)

ProgramLink.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    programLink: PropTypes.string
}

export default ProgramLink;
